import React from 'react'
import { Box, Text } from 'grommet'
import { Sync, View, Sort, Ascend } from 'grommet-icons'
import TooltipButton from '../Button/TooltipButton'
import { displayModifyTitleModal } from '../../redux/modal/actions'
import { useDispatch } from 'react-redux'
import MoreButton from './MoreButton'
import MenuIcon from '../MenuIcon'
import styled from 'styled-components'

const NoWrapText = styled(Text)`
  white-space: pre;
  font-weight: 500;
`

const HideSortTitleButton = ({ setHiding, choices, setChoices }) => {
  const dispatch = useDispatch()
  const openTitleModal = () => {
    dispatch(displayModifyTitleModal(true))
  }

  const menuItems = [
    {
      label: <NoWrapText>Shuffle</NoWrapText>,
      icon: <MenuIcon icon={<Sync color="secondary" size="small" />} />,
      onClick: () => shuffle(),
    },
    {
      label: <NoWrapText>Alphabetical Sort</NoWrapText>,
      icon: <MenuIcon icon={<Ascend color="secondary" size="small" />} />,
      onClick: () => sortAZ(),
    },
  ]

  const sortAZ = () => {
    let sortedArray = [...choices].sort((a, b) => a.name.localeCompare(b.name))
    dispatch(setChoices(sortedArray))
  }

  const shuffle = () => {
    let arra1 = choices.slice(0)
    let ctr = arra1.length
    let temp
    let index

    // While there are elements in the array
    while (ctr > 0) {
      // Pick a random index
      index = Math.floor(Math.random() * ctr)
      // Decrease ctr by 1
      ctr--
      // And swap the last element with it
      temp = arra1[ctr]
      arra1[ctr] = arra1[index]
      arra1[index] = temp
    }
    dispatch(setChoices(arra1.slice(0)))
  }

  return (
    <Box direction="row" gap=".5rem" alignSelf="center">
      <TooltipButton
        icon={<View color="iconDarkLight" />}
        clicked={() => {
          setHiding(true)
        }}
        message="Hide"
        position="top"
        color=""
        padding=".8rem"
      />
      <MoreButton
        menuItems={menuItems}
        icon={<Sort color="iconDarkLight" size="small" />}
        content="Sort"
      />
      <TooltipButton
        icon={
          <Box width="1.8rem" height="1.8rem" align="center" justify="center">
            <Text color="secondary" size="1.8rem">
              T
            </Text>
          </Box>
        }
        clicked={openTitleModal}
        message="Modify Title & Desc."
        position="right"
        color="secondary"
      />
    </Box>
  )
}

export default HideSortTitleButton
